














































































































































































































































































import { BuildTree } from "@/utils/base";
import { Component, Vue } from "vue-property-decorator";
import MainHeader from "@/components/main-header.vue";
import ZuzhiTree from "../../components/zuzhi-tree.vue";
import Empty from "@/components/empty.vue";
import {
  DelDevice,
  GetDeptData,
  GetDeviceList,
  GetDevicePatients,
  GetDeviceReports,
  GetUserList,
  PatchEditDevice,
  PostAddDevice,
} from "@/request/common";

@Component({
  components: {
    MainHeader,
    ZuzhiTree,
    Empty,
  },
})
export default class DeviceManage extends Vue {
  private treeKey: number = 1;
  private selectedDeptId: any = "";
  private searchText: string = "";
  private currentPage: number = 1;
  private pageSize: number = 20;
  private totalCount: number = 0;
  private devices: any[] = [];
  private institutions: any[] = [];
  private adminOptions: any[] = [];

  private deviceDialogVisible: boolean = false;
  private deviceForm: any = {
    id: "",
    dept: "",
    admin_user: "",
    device_name: "",
    device_id: "",
    baidu_serial_no: "",
    project_name: "",
    remark: "",
    status: true,
  };

  private patientDialogVisible: boolean = false;
  private currentDevice: any = {};
  private patientSearch: string = "";
  private patients: any[] = [];
  private reports: any[] = [];
  private selectedPatientId: any = "";

  private mounted() {
    this.loadDeptOptions();
    this.getDeviceList();
  }

  private goAdminManage() {
    this.$router.push("/main/account/zhanghu-list");
  }

  private search() {
    this.currentPage = 1;
    this.getDeviceList();
  }

  private selectDept(id: any) {
    this.selectedDeptId = id;
    this.currentPage = 1;
    this.getDeviceList();
  }

  private handleCurrentPageChange(page: number) {
    this.currentPage = page;
    this.getDeviceList();
  }

  private handleCurrentSizeChange(size: number) {
    this.pageSize = size;
    this.currentPage = 1;
    this.getDeviceList();
  }

  private loadDeptOptions() {
    const params: any = { params: {} };
    GetDeptData(this, params).then((res: any) => {
      this.institutions = BuildTree(res.data || []);
      this.treeKey += 1;
    });
  }

  private getDeviceList() {
    const params: any = {
      params: {
        page: this.currentPage,
        limit: this.pageSize,
        search: this.searchText,
      },
    };
    if (this.selectedDeptId) {
      params.params.dept = this.selectedDeptId;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中...",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetDeviceList(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.devices = res.data || [];
        this.totalCount = Number(res.total || 0);
      })
      .catch(() => {
        loading.close();
      });
  }

  private openCreateDevice() {
    if (!this.selectedDeptId) {
      this.$message.warning("请先在左侧选择机构");
      return;
    }
    this.deviceForm = {
      id: "",
      dept: this.selectedDeptId,
      admin_user: "",
      device_name: "",
      device_id: "",
      baidu_serial_no: "",
      project_name: "",
      remark: "",
      status: true,
    };
    this.loadAdminOptions(this.selectedDeptId);
    this.deviceDialogVisible = true;
  }

  private openEditDevice(row: any) {
    this.deviceForm = {
      id: row.id,
      dept: row.dept,
      admin_user: row.admin_user,
      device_name: row.device_name,
      device_id: row.device_id,
      baidu_serial_no: row.baidu_serial_no,
      project_name: row.project_name,
      remark: row.remark,
      status: row.status,
    };
    this.loadAdminOptions(row.dept);
    this.deviceDialogVisible = true;
  }

  private onDeviceDeptChange(deptId: any) {
    this.deviceForm.admin_user = "";
    if (deptId) {
      this.loadAdminOptions(deptId);
    } else {
      this.adminOptions = [];
    }
  }

  private loadAdminOptions(deptId: any) {
    const params: any = {
      params: {
        dept: deptId,
        page: 1,
        limit: 200,
      },
    };
    GetUserList(this, params).then((res: any) => {
      this.adminOptions = res.data || [];
    });
  }

  private saveDevice() {
    if (!this.deviceForm.dept) {
      this.$message.warning("请选择机构");
      return;
    }
    if (!this.deviceForm.admin_user) {
      this.$message.warning("请选择管理员");
      return;
    }
    if (!this.deviceForm.device_name) {
      this.$message.warning("请输入设备昵称");
      return;
    }
    const payload: any = {
      dept: this.deviceForm.dept,
      admin_user: this.deviceForm.admin_user,
      device_name: this.deviceForm.device_name,
      baidu_serial_no: this.deviceForm.baidu_serial_no,
      project_name: this.deviceForm.project_name,
      remark: this.deviceForm.remark,
      status: this.deviceForm.status,
    };
    const loading = this.$loading({
      lock: true,
      text: "保存中...",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const req = this.deviceForm.id
      ? PatchEditDevice(this, this.deviceForm.id, payload, loading)
      : PostAddDevice(this, payload, loading);
    req
      .then(() => {
        loading.close();
        this.$message.success("保存成功");
        this.deviceDialogVisible = false;
        this.getDeviceList();
      })
      .catch(() => {
        loading.close();
      });
  }

  private deleteDevice(row: any) {
    this.$confirm("确定删除该设备吗？", "删除设备", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "删除中...",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      DelDevice(this, row.id, loading)
        .then(() => {
          loading.close();
          this.$message.success("删除成功");
          this.getDeviceList();
        })
        .catch(() => {
          loading.close();
        });
    });
  }

  private openPatientDialog(row: any) {
    this.currentDevice = row;
    this.patientSearch = "";
    this.patients = [];
    this.reports = [];
    this.selectedPatientId = "";
    this.patientDialogVisible = true;
    this.loadDevicePatients();
  }

  private loadDevicePatients() {
    if (!this.currentDevice.id) {
      return;
    }
    const params: any = {
      params: {
        page: 1,
        limit: 200,
      },
    };
    if (this.patientSearch) {
      params.params.search = this.patientSearch;
    }
    GetDevicePatients(this, this.currentDevice.id, params).then((res: any) => {
      this.patients = res.data || [];
      this.reports = [];
      this.selectedPatientId = "";
      if (this.patients.length > 0) {
        this.selectPatient(this.patients[0]);
      }
    });
  }

  private selectPatient(row: any) {
    if (!this.currentDevice.id || !row || !row.id) {
      return;
    }
    this.selectedPatientId = row.id;
    const params: any = {
      params: {
        page: 1,
        limit: 200,
        patient_id: row.id,
      },
    };
    GetDeviceReports(this, this.currentDevice.id, params).then((res: any) => {
      this.reports = res.data || [];
    });
  }
}
